import React from "react";

import "./styles.css";

const Logo = () => {
    const whatsapp = () => {
        let url = `https://wa.me/${573175075669}`;

        url += `?text=${encodeURI(
            "Hola, Me encuentro interesad@ en conocer los proyectos de apartamentos que ví en su página web."
        )}`;

        window.open(url);
    };

    return (
        <img
            src="/images/icons/whatsapp.png"
            className="container-whatsapp"
            onClick={whatsapp}
            alt="WhatsApp"
        />
    );
};

export default Logo;
